/**
 * Размеры от двери или окна до углов стены — пока проём ставят или двигают вдоль стены:
 * от каждого края проёма до ближайшей поперечной стены, по обеим граням стены.
 * Считает `openingClearances` в `widgets/plan/clearances.ts`, рисует та же линия, что
 * у размеров по Ctrl/Cmd. На лист PDF не попадают.
 */
import { openingClearances, type Room, type WallGraph, type WallOutline } from "../../plan";
import { ClearanceLine } from "../floor/Clearances2D";

interface Props {
	graph: WallGraph;
	/** Место проёма на стене: поставленного или призрака */
	opening: { wallId: string; offset: number; width: number };
	rooms: Room[];
	outlines: Record<string, WallOutline>;
	mmPerPx: number;
}

export const OpeningClearances2D = ({ graph, opening, rooms, outlines, mmPerPx }: Props) => (
	<g data-plan-export-exclude style={{ pointerEvents: "none" }}>
		{openingClearances(graph, opening, rooms, outlines).map((clearance) => (
			<ClearanceLine
				key={`${Math.round(clearance.from.x)}:${Math.round(clearance.from.y)}:${Math.round(clearance.to.x)}:${Math.round(clearance.to.y)}`}
				clearance={clearance}
				mmPerPx={mmPerPx}
			/>
		))}
	</g>
);
